import { Filter } from '@/components/filter/FilterModel';
import { DisplayOption } from '@/components/interfaces/ComponentOptions';
import { BusinessResidence } from "@/products-and-services/ProductsServicesModels";

export interface Grouping {
    id: number;
    name: string;
    displayOrder: number;
    type: GroupingType;
    show?: boolean;
    businessResidence: BusinessResidence;
}

export enum GroupingType {
    PACKAGE = 'Package',
    PREMIUM = 'Premium'
}

export const ChannelTypeOptions: DisplayOption[] = [
    { id: GroupingType.PACKAGE, name: GroupingType.PACKAGE },
    { id: GroupingType.PREMIUM, name: GroupingType.PREMIUM },
]
export const BusinessChannelTypeOptions: DisplayOption[] = [
    { id: GroupingType.PACKAGE, name: GroupingType.PACKAGE },
    { id: GroupingType.PREMIUM, name: 'A la Carte' },
]
export interface Channel {
    id: number;
    isOffered: boolean;
    businessResidence: BusinessResidence;
    name: string;
    channelNumber: string;
    highDefinitionChannelNumber: string;
    channelType: GroupingType;
    groupingId?: string;
    businessType?: BusinessType;
    businessChannelType?: GroupingType;
    businessGroupingId?: string;
    businessChannelPackages?: string[]
    businessCategories?: string[];
    channelPackages?: string[]
    categories?: string[];
    show?: boolean;
}

export interface ChannelFilterData {
    offeredFilter: Filter;
    channelTypeFilter: Filter;
    packageFilter: Filter;
    groupFilter: Filter;
    categoryFilter: Filter;
    businessResidenceFilter: Filter;
    businessTypeFilter: Filter;
}

export interface ChannelCategory {
    id: string;
    name: string;
    businessResidence: BusinessResidence;
}

export interface ChannelPackage {
    id: string;
    name: string;
    businessResidence: BusinessResidence;
}

export enum BusinessType {
    TAVERN = 'Tavern',
    STANDARD = 'Standard'
}

export const BusinessTypeOptions: DisplayOption[] = [
    { id: BusinessType.TAVERN, name: BusinessType.TAVERN },
    { id: BusinessType.STANDARD, name: BusinessType.STANDARD }
]